import { RouteName } from "@/apps/merchant3/router/RouteName";
import { RouteRecordName } from "vue-router";

// TODO: Ideally this will call the backend to handle prev step. For now we still handle it in the frontend
export const getNextStep = (currentRoute: RouteRecordName): string | null => {
  switch (currentRoute) {
    case RouteName.M3Imei:
      return RouteName.M3Contract;
    default:
      return null;
  }
};
